import React from 'react';
import './App.css';
import Forms from './Forms';
import Footer from './Footer';

function Reepas() {
  return (
    <div className="Reepas">
      <div className="main-content">
        <Forms />
      </div>
      <Footer />
    </div>
  );
}

export default Reepas;